import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fmg_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    const t = localStorage.getItem("fmg_token");
    if (!t) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("fmg_user", JSON.stringify(data));
    } catch (e) {
      // Only discard the session on an actual auth failure — transient
      // network errors must not log the member out.
      if (e?.response?.status === 401) logout();
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("fmg_token", data.token);
      localStorage.setItem("fmg_user", JSON.stringify(data.user));
      setUser(data.user);
      // Immediately hydrate the full user (incl. profile) so SPA navigation
      // to Profile never renders a falsely blank form.
      await refresh();
      return data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("fmg_token", data.token);
      localStorage.setItem("fmg_user", JSON.stringify(data.user));
      setUser(data.user);
      await refresh();
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("fmg_token");
    localStorage.removeItem("fmg_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, loading, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
